import apiClient from '@/core/api/client';
import { API_ENDPOINTS } from '@/core/api/endpoints';
import { ClassRequest, ClassResponse, ClassListResponse } from '../types';

export const classApi = {
    getClasses: async (schoolSlug: string, params?: { page?: number; page_size?: number }): Promise<ClassListResponse> => {
        try {
            const response = await apiClient.get<ClassListResponse>(API_ENDPOINTS.CLASSES.LIST(schoolSlug), { params });
            return response.data;
        } catch (error: any) {
            return {
                success: false,
                error: error.response?.data?.error || error.response?.data?.message || 'Failed to fetch classes'
            };
        }
    },

    createClass: async (schoolSlug: string, data: ClassRequest): Promise<ClassResponse> => {
        try {
            const response = await apiClient.post<ClassResponse>(API_ENDPOINTS.CLASSES.CREATE(schoolSlug), data);
            return response.data;
        } catch (error: any) {
            return {
                success: false,
                error: error.response?.data?.error || error.response?.data?.message || 'Failed to create class'
            };
        }
    },

    updateClass: async (schoolSlug: string, classId: string, data: ClassRequest): Promise<ClassResponse> => {
        try {
            const response = await apiClient.patch<ClassResponse>(API_ENDPOINTS.CLASSES.UPDATE(schoolSlug, classId), data);
            return response.data;
        } catch (error: any) {
            return {
                success: false,
                error: error.response?.data?.error || error.response?.data?.message || 'Failed to update class'
            };
        }
    },

    deleteClass: async (schoolSlug: string, classId: string): Promise<ClassResponse> => {
        try {
            const response = await apiClient.delete<ClassResponse>(API_ENDPOINTS.CLASSES.DELETE(schoolSlug, classId));
            return response.data;
        } catch (error: any) {
            return {
                success: false,
                error: error.response?.data?.error || error.response?.data?.message || 'Failed to delete class'
            };
        }
    }
};
